import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions, Typography } from '@mui/material';
import React from 'react';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'

export type AlertDialogPropsType = {
  removeAttachment: () => void
  fileName: string
}

export const AlertDialog = (props: AlertDialogPropsType) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseOnOK = () => {
    props.removeAttachment()
    setOpen(false);
  }

  return (
    <div>
      <Typography onClick={handleClickOpen} >
            <DeleteForeverIcon fontSize='small' style={{ cursor: 'pointer' }} />
          </Typography>
    
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Delete attachment
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete {props.fileName} ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleCloseOnOK} variant="contained" color="info" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}